export const getBrowseStyles= `
query GetBrowseStyleProducts {
    getBrowseStyleProducts {
        ProductId
        ProductName
        Category
        VehicleType
        SampleImageId
        ListPrice
        VariantsInBrowseStyle {
            VariantId
            VariantName
            ColourCatalogId
            Colour
            ColourSelectorHexFont
            ColourSelectorHexOuter
            ColourInfo {
                ColourCatalogId
                Colour
                DisplayName
                FilterPrimaryColour
                FilterSecondaryColour
                ColourSelectorHexFont
                ColourSelectorHexOuter
                VRISColourCatalog
                VRISLetterColour
            }
            CostInfoForCreate {
              CPMTransType
              Cost
              CostEffectiveDateFrom
              CostEffectiveDateTo
            }
            PlateThemeId
            ThemeName
            ThemeInfo {
              Theme
            }
            SizeInfo {
                PlateSizeId
                SloganId
                SizeCode
                SizeDescription
                PlateWidth_mm
                PlateHeight_mm
                SloganDesc {
                    SloganId
                    SloganDescription
                    SloganText
                }
            }
        }
    }
}
`

export const validatePlateNumber = `
query getPlateRule($PlateCombo: String, $VehicleType: Int, $SalesChannel: Int) {
  getPlateRuleEngineStatus(PlateCombo: $PlateCombo, VehicleType: $VehicleType, SalesChannel: $SalesChannel) {
    PlateCombo
    VehicleType,
    IsPerpetual,
    Status
  }
}`

export const checkOwnership = `
query getPlateCheckOwnership($PlateCombo: String, $VehicleType: Int, $CustomerNumber: String) {
  getPlateCheckOwnership(PlateCombo: $PlateCombo, VehicleType: $VehicleType, CustomerNumber: $CustomerNumber) {
    CustomerNumber,
    PlateCombo,
    Status
  }
}`

export const getRestyleCheckStatus = `
query getRestyleCheckStatus($PlateCombo: String, $VehicleType: Int, $SalesChannel: Int) {
  getRestyleCheckStatus(PlateCombo: $PlateCombo, VehicleType: $VehicleType, SalesChannel: $SalesChannel) {
    PlateCombo
    VehicleType,
    IsPerpetual,
    Status
  }
}`

export const getPlateStyles = `
query getProductsWithVariantsByCombination($CombinationType: String!, $VehicleTypeId: Int!, $SalesChannel: Int!) {
  getProductsWithVariantsByCombination(CombinationType: $CombinationType, VehicleTypeId: $VehicleTypeId, SalesChannel: $SalesChannel) {
    BROWSESortOrder
    CategoryId
    IsAvailable
    NEWSortOrder
    SampleImageId
    ProductId
    ProductName
    ListPrice
    CategoryDesc {
      CategoryName
    }
    VariantsInProduct {
      CostInfoForCreate {
        Cost
      }
      ColourInfo {
        Colour
        ColourSelectorHexOuter
        DisplayName
      }
      ThemeInfo {
        Theme
      }
      SizeInfo {
        SizeCode
      }
    }
  }
}`

export const getRestylePlateStyles = `
query getRestyleProductsWithVariantsByCombination($CombinationType: String!, $VehicleTypeId: Int!, $SalesChannel: Int!) {
  getRestyleProductsWithVariantsByCombination(CombinationType: $CombinationType, VehicleTypeId: $VehicleTypeId, SalesChannel: $SalesChannel) {
    BROWSESortOrder
    CategoryId
    IsAvailable
    RESTYLESortOrder
    SampleImageId
    ProductId
    ProductName
    ListPrice
    CombinationType
    CategoryDesc {
      CategoryName
    }
    VariantsInProductRestyle {
      CostInfoForRestyle {
        Cost
      }
      ColourInfo {
        Colour
        ColourSelectorHexOuter
        DisplayName
      }
      ThemeInfo {
        Theme
      }
      SizeInfo {
        SizeCode
      }
    }
  }
}`

export const getVariantWithColourThemeAndPlatesByProductId = `
query getVariantWithColourThemeAndPlates($ProductId: Int!, $CombinationType: String, $SalesChannel: Int!, $IsDisplayBrowse: Boolean!){
  getVariantByProductId(ProductId: $ProductId, CombinationType: $CombinationType, SalesChannel: $SalesChannel, IsDisplayBrowse: $IsDisplayBrowse ) {
    PlateSizeId
    ProductId
    ImageFontType
    ImageFontSize
    Char1Position
    VariantId
    VariantName
    ThemeInfo {
      Theme
    }
    SizeInfo {
      SizeCode
      PlateWidth_mm
      PlateHeight_mm
      SizeDescription
      SloganDesc {
        SloganDescription
        SloganId
        SloganText
      }
    }
    CostInfoForCreate {
      Cost
    }
    ColourInfo {
      Colour
      DisplayName
      ColourSelectorHexFont
      ColourSelectorHexOuter
    }
    Char2Position
    Char3Position
    Char4Position
    Char5Position
    Char6Position
    Char7Position
    CharsBaseline
    FontDarkeningFactor
    ConvolutionMatrix
    BaseImageId
    IsOOE
  }
}`

export const getVariantWithColourThemeAndPlatesByProductIdForRestyle = `
query getVariantWithColourThemeAndPlates($ProductId: Int!, $CombinationType: String, $SalesChannel: Int!){
  getVariantByProductIdForRestyle(ProductId: $ProductId, CombinationType: $CombinationType, SalesChannel: $SalesChannel) {
    PlateSizeId
    ProductId
    ImageFontType
    ImageFontSize
    Char1Position
    VariantId
    VariantName
    ThemeInfo {
      Theme
    }
    SizeInfo {
      SizeCode
      PlateWidth_mm
      PlateHeight_mm
      SizeDescription
      SloganDesc {
        SloganDescription
        SloganId
        SloganText
      }
    }
    CostInfoForRestyle {
      Cost
    }
    ColourInfo {
      Colour
      DisplayName
      ColourSelectorHexFont
      ColourSelectorHexOuter
    }
    Char2Position
    Char3Position
    Char4Position
    Char5Position
    Char6Position
    Char7Position
    CharsBaseline
    FontDarkeningFactor
    ConvolutionMatrix
    BaseImageId
    IsOOE
  }
}`

export const generateOrderNumber = `
query generateNextOrderNumber($OrderNumberType: String!, $OrderNumberFormat: String!) {
  generateNextOrderNumber(OrderNumberType: $OrderNumberType, OrderNumberFormat: $OrderNumberFormat)
}
`


export const getAllMiscVariants = `
query getAllMiscVariants {
  getAllMiscVariants {
    Id
    DisplayValue
    MidrangeProductId
    ProductId
    IsAvailable
  }
}`

export const getMiscVariantById = `
query getMiscVariantById($id: Int!) {
  getMiscVariantById(Id: $id) {
    Id
    DisplayValue
    CostInfo {
      Cost
    }
  }
}`

export const getVoucherBalance = `
query getVoucherBalance($code: String!) {
  getVoucherBalance(code: $code) {
    last4
    balance
    currency
    expiresAt
    status
  }
}`

